import { Component, OnInit } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { ContactBook, ContactType } from './contactBook';
import { ReactiveFormsModule } from '@angular/forms';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { required } from '../../../../../../../shared/utils';

const NODE_TYPE = 'contactBook';

@Component({
  selector: 'app-contact-book',
  templateUrl: './contact-book.component.html',
  styleUrls: ['./contact-book.component.scss'],
  imports: [
    ClickatellExpansionPanelComponent,
    MatExpansionPanelTitle,
    ReactiveFormsModule,
    ClickatellFormValidationComponent,
    ActiveFormDirective,
    CMSComponent,
    NextSelectorComponent,
    MatSlideToggle,
  ],
})
export class ContactBookComponent extends NodeBuilder implements OnInit {
  contactType: ContactType = 'lookup';

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {}

  set buildForm(stepData: { [index: string]: any }) {
    this.formGroup = ContactBook.toForm(stepData, this.canEdit);
    this.contactType = this.formGroup.get('contactType').value;
    this.updateValidators();
    this.setAllNextStepValues = ['yes', 'no'];
  }

  get getStepData(): {} {
    const formData = this.formGroup.getRawValue();
    return new ContactBook(formData).nodeData;
  }

  get isNodeValid(): boolean {
    return this.isValidateForm();
  }

  onContactTypeChange(value: ContactType): void {
    this.contactType = value;
    if (value !== 'insert') {
      this.formGroup.get('useReturnFlow').setValue(false);
    }
    this.updateValidators();
  }

  private updateValidators(): void {
    const msisdn = this.formGroup.get('msisdn');
    msisdn.clearValidators();

    if (this.contactType === 'insert') {
      msisdn.setValidators(required('MSISDN'));
    }

    msisdn.updateValueAndValidity();
  }

}
